/**
 * Full-screen overlay shown while logout API is in progress.
 * Transparent, blurred, with "Logging out..." and a small loader.
 *
 * @author Varun Pandey
 */

import React from 'react';
import { Loader } from './Loader';

export const LoggingOutOverlay: React.FC = () => (
  <div
    className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-black/20 backdrop-blur-sm"
    aria-live="polite"
    aria-busy="true"
  >
    <p className="text-white text-sm font-medium mb-3">Logging out...</p>
    <Loader size="small" className="text-white" />
  </div>
);
